// extracted by mini-css-extract-plugin
module.exports = {"list":"EffectsList-module--list--3JXh1","item":"EffectsList-module--item--idXPD","description":"EffectsList-module--description--10Jms","title":"EffectsList-module--title--pMH0T"};